import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__container _container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "14",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.70711 0.292893C7.31658 -0.0976311 6.68342 -0.0976311 6.29289 0.292893L0.292894 6.29289C0.24408 6.34171 0.201365 6.39431 0.164753 6.44977C-0.0915279 6.83792 -0.0488167 7.3654 0.292894 7.70711L6.29289 13.7071C6.68342 14.0976 7.31658 14.0976 7.70711 13.7071C8.09763 13.3166 8.09763 12.6834 7.70711 12.2929L3.41421 8H16.1176C16.605 8 17 7.55228 17 7C17 6.44772 16.605 6 16.1176 6H3.41421L7.70711 1.70711C8.09763 1.31658 8.09763 0.683418 7.70711 0.292893Z",
    fill: "#667387"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "header__admin"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.1105 2.00664C12.7825 0.877127 14.2532 0.45668 15.4127 1.14206L17.1372 2.12895C18.4098 2.85617 18.8414 4.48725 18.1145 5.74534L18.114 5.74624C17.7391 6.3931 17.7979 6.80632 17.9149 7.00941C18.032 7.21262 18.3599 7.47013 19.1051 7.47013C20.5568 7.47013 21.7551 8.65335 21.7551 10.1201V11.8801C21.7551 13.3318 20.5719 14.5301 19.1051 14.5301C18.3599 14.5301 18.032 14.7877 17.9149 14.9909C17.7979 15.1939 17.7391 15.6072 18.114 16.254L18.1163 16.258C18.8395 17.5236 18.4108 19.1432 17.1376 19.8711L15.4126 20.8583C14.2531 21.5436 12.7825 21.1231 12.1106 19.9936L12.106 19.9859L11.996 19.7959L11.9944 19.7931C11.6244 19.1477 11.2385 18.9926 11.0039 18.9926C10.7681 18.9926 10.3793 19.149 10.0042 19.7959L9.88972 19.9936C9.21775 21.1231 7.7471 21.5436 6.58769 20.8583L4.86301 19.8713C3.5907 19.144 3.1589 17.5129 3.88572 16.2549L3.88624 16.254C4.26117 15.6072 4.20233 15.1939 4.08529 14.9909C3.96819 14.7877 3.64033 14.5301 2.89512 14.5301C1.42834 14.5301 0.245117 13.3318 0.245117 11.8801V10.1201C0.245117 8.66849 1.42834 7.47013 2.89512 7.47013C3.64033 7.47013 3.96819 7.21262 4.08529 7.00941C4.20233 6.80632 4.26117 6.3931 3.88624 5.74624L3.88572 5.74534C3.1589 4.48738 3.59029 2.85651 4.86261 2.12918L6.5876 1.14205C7.74703 0.456684 9.21769 0.877159 9.88967 2.00666L9.89423 2.01433L10.0042 2.20436L10.0058 2.20714C10.3758 2.85259 10.7617 3.00763 10.9964 3.00763C11.2321 3.00763 11.621 2.85128 11.996 2.20435L12.1105 2.00664ZM16.1449 3.86544C16.4501 4.03983 16.5582 4.44114 16.3828 4.74472C15.7857 5.77567 15.591 6.98227 16.1821 8.00801C16.7734 9.03404 17.9152 9.47013 19.1051 9.47013C19.4596 9.47013 19.7551 9.76535 19.7551 10.1201V11.8801C19.7551 12.2346 19.4599 12.5301 19.1051 12.5301C17.9152 12.5301 16.7734 12.9662 16.1821 13.9923C15.5913 15.0174 15.7855 16.2231 16.3817 17.2537C16.5607 17.571 16.4464 17.9625 16.1443 18.1352L14.4192 19.1224L14.3949 19.1365C14.2265 19.236 13.9645 19.1954 13.8307 18.9733L13.7296 18.7985L13.7288 18.7971L13.728 18.7957C13.1352 17.7633 12.1878 16.9926 11.0039 16.9926C9.82064 16.9926 8.87125 17.7626 8.27396 18.7928L8.16711 18.9773C8.03266 19.1959 7.77273 19.2355 7.60535 19.1365L7.58104 19.1224L5.85559 18.135C5.55009 17.9604 5.44237 17.5586 5.61745 17.2555C6.21452 16.2245 6.40926 15.018 5.81815 13.9923C5.22688 12.9662 4.08499 12.5301 2.89512 12.5301C2.54033 12.5301 2.24512 12.2346 2.24512 11.8801V10.1201C2.24512 9.76562 2.54033 9.47013 2.89512 9.47013C4.08499 9.47013 5.22688 9.03403 5.81816 8.008C6.40936 6.98208 6.21445 5.7753 5.61713 4.74424C5.44219 4.44075 5.55102 4.03938 5.85597 3.86505L7.58096 2.87792L7.60533 2.86374C7.77367 2.76423 8.03571 2.80483 8.16948 3.02695L8.27066 3.20179L8.27135 3.203L8.27217 3.20442C8.86489 4.2369 9.81235 5.00763 10.9964 5.00763C12.1796 5.00763 13.129 4.23771 13.7263 3.20749L13.8331 3.02295C13.9676 2.80437 14.2275 2.7648 14.3949 2.86374L14.4193 2.87793L16.1449 3.86544ZM9.25 11C9.25 10.0335 10.0335 9.25 11 9.25C11.9665 9.25 12.75 10.0335 12.75 11C12.75 11.9665 11.9665 12.75 11 12.75C10.0335 12.75 9.25 11.9665 9.25 11ZM7.25 11C7.25 8.92893 8.92893 7.25 11 7.25C13.0711 7.25 14.75 8.92893 14.75 11C14.75 13.0711 13.0711 14.75 11 14.75C8.92893 14.75 7.25 13.0711 7.25 11Z",
    fill: "#667387"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["header__back", { 'active-back': _ctx.isActiveBack }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeBack())),
        style: {"cursor":"pointer"}
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["header__link", { 'active-back': _ctx.isActiveBack }])
      }, [
        _createVNode(_component_router_link, {
          class: "header__title",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Привилегии")
          ]),
          _: 1
        })
      ], 2),
      (_ctx.currentUser && _ctx.currentUser.role == 'admin' && !_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/admin/dashboard",
              style: {"display":"flex"}
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}